import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../auth.service';
import { UserRole } from '../user-role.enum';

@Injectable({
  providedIn: 'root',
})
export class CompanyGuard  {
  constructor(public authService: AuthService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.authService
      .getUser()
      .pipe(
        map(
          (user) =>
            user.role.name === UserRole.COMPANY ||
            user.role.name === UserRole.NGO ||
            user.role.name === UserRole.ADMIN
        )
      );
  }
}
